<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17yG8We/tc-custom/9781626811256.jpg?1701061331243" alt="This image is the cover for the book Quinn"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Quinn
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A novel of an unlikely college romance and the choices we face on the cusp of independence, by a <i>New York Times</i>–bestselling author. </b><br/>  <br/> Headstrong and beautiful Quinn Mallory meets Will Ingraham at college in the 1960s. Their personalities couldn’t be more different, but a true love blossoms between them that, they believe, will last forever.<br/>  <br/> But eventually, Quinn’s dreams of a career in the big city will collide with Will’s longing for a quiet life together in his Idaho home—leaving Quinn to choose between the life she wants and the man she loves, in this moving, poignant novel by an author who “has a gift for true and incisive dialogue” (<i>Publishers Weekly</i>).<br/>  <br/> “A novel full of fresh characters in a timeless setting . . . . A delightful book to read and reread.” —<i>The Pittsburgh Press</i><br/>  <br/> “Her novels will inspire you with love, laughter and courage.” —Luanne Rice, author of <i>The Secret Language of Sisters</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sally Mandel
      </h2>
      
      <p class="authorDescription body article">Sally Mandel is the author of seven novels: <I>Heart and Soul</I>, <I>Out of the Blue</I>, <I>A Time to Sing</I>, <I>Portrait of a Married Woman<I>, <I>Quinn</I>, <I>Change of Heart</I>, </I></I>and&#160;<I><I><I>Take Me Back</I>. <I>Change of Heart&#160;</I></I></I>was on the <I>New York Times&#160;</I>bestseller list for ten weeks. The film rights were sold to Columbia Pictures.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2d72fac7